(function () {
  'use strict';

  function initCardSwipe(card) {
    var track = card.querySelector('.card-swipe-track');
    var dots = Array.prototype.slice.call(card.querySelectorAll('.card-swipe-dot'));
    var slides = Array.prototype.slice.call(card.querySelectorAll('.card-swipe-slide'));
    if (!track || dots.length < 2 || slides.length < 2) return;

    var current = 0;

    function setDot(idx) {
      if (idx === current || idx < 0 || idx >= dots.length) return;
      dots[current].classList.remove('active');
      current = idx;
      dots[current].classList.add('active');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setDot(slides.indexOf(entry.target));
        }
      });
    }, { root: track, threshold: 0.55 });

    slides.forEach(function (slide) { observer.observe(slide); });
  }

  function initAll() {
    document.querySelectorAll('.product-card').forEach(initCardSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var grid = document.getElementById('product-grid');
  if (grid) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('product-card')) {
            initCardSwipe(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.product-card').forEach(initCardSwipe);
          }
        });
      });
    }).observe(grid, { childList: true, subtree: true });
  }
})();
